import React, { forwardRef } from 'react'
import { Link as MuiLink, LinkProps } from '@material-ui/core'

import { useLinkStyles } from './LinkStyles'

interface LinkType {
  <C extends React.ElementType = 'a'>(props: LinkProps<C> & { component?: C }): React.ReactElement
  displayName?: string
}

// eslint-disable-next-line react/display-name -- false positive
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ variant = 'body1', ...restProps }, ref) => {
  const props = { ...restProps, variant }
  const { children, ...muiProps } = props
  const classes = useLinkStyles(props)

  return (
    <MuiLink ref={ref} classes={{ root: classes.root }} {...muiProps}>
      {children}
    </MuiLink>
  )
}) as LinkType

Link.displayName = 'Link'
